<template>
  <div>
    <img src="../../assets/image/footer.png" alt="Global Image" />
  </div>
</template>

<script>
export default {
  name: 'GlobalImage'
}
</script>
<style scoped>
img{
  width: 100%;
  height: 100%;
}
</style>/
